<template>
	<div>
		<div
			v-if="!hideVendorSpinner"
			class="spinner-border"
			style="margin:auto;display:block;margin-top:60px"
		></div>
		<div v-else>
			<div class="form-group row" v-if="isMultiSelect == 'false'">
				<label for="tags" class="col-sm-2 col-form-label">{{label}} <sup v-if='mandatory'>*</sup></label>
				<div :class="inputCols?inputCols:'col-sm-5'" v-if="!dataLoading">
					<!-- <select
						class="form-control"
						v-model="modalValue"
						v-bind:disabled="nonEditable ? true : false"
						@change="setSelected();resetSubmitForm()"
						:id='"my-select" + modalValue'
						:class="{ 'is-invalid': submitted && !(this.modalValue.length>0) }"
					> -->
					<multiselect
						:id='"my-select" + modalValue'
						v-model="modalValue"
						:options="dropdownList"
						:show-no-results="true"
						:searchable="true"
						:label="useMasterId?'vendor_name':'name'"
						:track-by="setTrackBy()"
						open-direction="bottom"
						:disabled = "nonEditable ? true : false"
						:taggable="false"
						:placeholder="placeholder||'Search...'"
						class="form-control multi-dropdown select_filter"
						selectLabel = ""
						selectedLabel = ""
						@select = "setSelected($event);resetSubmitForm()"
						@remove = "removed"
						/>

						<!-- <option :value="0">{{selection}}</option>
						<option
							v-for="item in dropdownList"
							:key="( isVendor ? item.id : ( isProduct ? item.asin : (fromBrandData ? item.ams_profile_id : item.id) ) )"
							:value="( isVendor ? item.id : ( isProduct ? item.asin : (fromBrandData ? item.ams_profile_id : item.id)) )"
						>{{ (isProduct ? item.product_title : item.name) }}</option>
					</select> -->
					<span v-if="submitted && !(this.modalValue.length>0)" class="invalid-feedback">This field is required</span>
				</div>
				<div class="col-sm-1" v-if="dataLoading">
					<div class="spinner-border" role="status">
						<span class="sr-only"></span>
					</div>
				</div>
			</div>
			<div v-else>
				<div class="col-sm-1 offset-sm-2" v-if="dataLoading">
					<div class="spinner-border" role="status">
						<span class="sr-only"></span>
					</div>
				</div>
				<DropDownMultiSelect v-if="!dataLoading"
					:label="label"
					@setSelectedProduct="setSelectedProduct"
					:productVal="productVal"
					:nonEditable="nonEditable"
					:mandatory="mandatory"
					:placeholder="placeholder"
				/>
			</div>
		</div>
	</div>
</template>

<script>
	import DropDownMultiSelect from "./DropDownMultiSelect.vue";
	import Multiselect from "vue-multiselect";

	export default {
		name: "CampaignFormDropDown",
		components: { DropDownMultiSelect, Multiselect },
		data() {
			return {
				list: [],
				modalValue: {},
				productList: [],
				isNewselected: false,
				hideVendorSpinner: true,
				submitted:false
			};
		},
		computed: {

		},
		props: {
			isVendor: Boolean,
			isBrand: Boolean,
			label: String,
			selection: String,
			isProduct: Boolean,
			fromProduct: String,
			isMultiSelect: String,
			brandVal: String,
			productVal: Array,
			nonEditable: Boolean,
			vendor_name: String,
			brand_name: String,
			dataLoading: Boolean,
			dropdownList: Array,
			selectedValue: String,
			selectedList: Array,
			mandatory: Boolean,
			fromBrandData: Boolean,
			isCampaignType:Boolean,
			isStateType:Boolean,
			calledFrom: String,
			inputCols:String,
			placeholder:String,
			useMasterId:Boolean,
			getRemoveAlso:Boolean
		},
		mounted() {
			this.prePopulateData()

		//	this.modalValue = this.selectedValue ? this.selectedValue : this.selectedList
		},
		methods: {
			removed(){
				if(this.getRemoveAlso){
					this.$emit("showNextView", null)
				}
			},
			resetSubmitForm(){
				this.submitted = false;
				console.log(this.modalValue);
			},
			setSelected(selectedVal) {
				console.log(this.modalValue);
				// let data = '';
				// if(this.isVendor){
				// 	data = selectedVal.id;
				// }
				// else{
				// 	data = selectedVal.ams_profile_id;
				// }
				this.$emit("showNextView", selectedVal)
				if (this.isProduct) {
					this.productList.push(this.modalValue);
					this.$emit("showNextView", this.productList);
					}
			},
			setTrackBy(){
				return  this.isVendor ? "id" : ( this.isProduct ? "asin" : (this.fromBrandData ? "ams_profile_id" : "id"))
			},
			validate(){

				if(this.modalValue && Array.isArray(this.modalValue)){
					if(this.modalValue && !this.modalValue.length>0){
						this.submitted = true;
						$(`#my-select${this.modalValue}`).focus();
						return false;
					}
					else{
						this.submitted = false;
						return true;
					}
				}
				else if(this.modalValue && typeof this.modalValue == 'object'){
					if(!this.modalValue.id && !this.modalValue.name){
						this.submitted = true;
						$(`#my-select${this.modalValue}`).focus();
						return false;
					}
					else{
						this.submitted = false;
						return true;
					}
				}

			},
			setSelectedProduct(data) {
				// if (data.length) {
				// 	this.list = data.map(res => {
				// 		return res.asin;
				// 	});
					this.$emit("showNextView", data);
			//	}
		},
		prePopulateData(){
			if(this.selectedValue == []){
				this.modalValue = []
			}
			else{
				if(this.isVendor){
					this.populateVendor()
				}
				if(this.isBrand){
					this.populateBrand()
				}
				if(this.isCampaignType){
					this.modalValue = [{id:this.selectedValue, name:this.selectedValue}]
				}
				if(this.isStateType){
					this.modalValue = [{id:this.selectedValue, name:this.selectedValue}]
				}
			}
		},
		populateBrand(){
			this.modalValue = [{id:this.selectedValue, vendor_name: this.vendor_name, name: this.brand_name}]
		},
		populateVendor(){
			this.modalValue = [{id:this.selectedValue, vendor_name: this.vendor_name, name: this.brand_name}]
		},
		resetModalValue(){
			this.modalValue = {}
		},
		}
	};
</script>

<style lang="scss">
</style>
